import { getMaxAmountByCurrency } from '../../../../utils/getMaxAllowableAmount';

export const createValidationConfig = (getLocalization, currencyCode, storeNumber = null) => ({
  fields: {
    depositSlip: {
      MIN: `${getLocalization('lbl.deposit-slip')} ${getLocalization('msg.is-a-required-field')}`,
      DUPLICATE: getLocalization('msg.duplicate-deposit-slip'),
    },
    depositAmount: {
      NONNEGATIVE: getLocalization('msg.number-must-be-positive'),
      MAX: getLocalization('msg.number-exceeds-max'),
      MAX_AMOUNT: getMaxAmountByCurrency(currencyCode, storeNumber),
    },
  },
  variance: {
    short: {
      VALUE: 'Short',
      LABEL: getLocalization('lbl.variance-short'),
    },
    over: {
      VALUE: 'Over',
      LABEL: getLocalization('lbl.variance-over'),
    },
    none: {
      VALUE: 'No Variance',
      LABEL: getLocalization('lbl.no-variance'),
    },
  },
});
